import { formatDate } from '../../helpers/date';
import { EducationLevel, EducationSubLevel, LearningPath } from '../EducationLevels';
import {
    SchoolExperience,
    SchoolExperienceFormData,
    SchoolExperienceRequest,
    SchoolExperienceResource,
} from './SchoolExperience';

export const transformToSchoolExperience = (
    schoolExperienceResource: SchoolExperienceResource,
): SchoolExperience => ({
    id: schoolExperienceResource.id,
    educationLevel: schoolExperienceResource.educationLevel as EducationLevel,
    educationSubLevel: schoolExperienceResource.educationSubLevel as EducationSubLevel,
    learningPath: schoolExperienceResource.learningPath as LearningPath,
    fieldOfStudy: schoolExperienceResource.degree,
    fieldOfStudyId: '', // Not used directly, only when a new field of study has been selected
    school: schoolExperienceResource.school,
    startDate: new Date(schoolExperienceResource.startDate),
    endDate: new Date(schoolExperienceResource.endDate),
});

export const transformToSchoolExperienceRequest = (
    schoolExperienceFormData: SchoolExperienceFormData,
): SchoolExperienceRequest => {
    const startDate = formatDate(schoolExperienceFormData.startDate, 'y-MM-dd');
    const endDate = formatDate(schoolExperienceFormData.endDate, 'y-MM-dd');

    return {
        id: schoolExperienceFormData.id,
        educationLevel: schoolExperienceFormData.educationLevel,
        educationSubLevel: schoolExperienceFormData.educationSubLevel,
        learningPath: schoolExperienceFormData.learningPath,
        degree: schoolExperienceFormData.fieldOfStudy,
        school: schoolExperienceFormData.school,
        startDate,
        endDate,
    };
};
